import {
    fetchSlotPluginsConfig as fetchSlotPluginsConfigFromHost,
    resolveSlotPluginsConfigUrlOverride,
    type SlotPluginsConfig,
} from '@yandex-360/360-plugin-host';

function getSlotPluginsConfigUrlOverride(enabled: boolean): string | null {
    if (typeof window === 'undefined') {
        return null;
    }

    return resolveSlotPluginsConfigUrlOverride(window.location.search, enabled);
}

export function getSlotPluginsConfigUrl(enabled: boolean, configUrl?: string | null): string | null {
    if (!enabled) {
        return null;
    }

    const overrideUrl = getSlotPluginsConfigUrlOverride(enabled);

    if (overrideUrl) {
        return overrideUrl;
    }

    if (typeof configUrl !== 'string') {
        return null;
    }

    const trimmedValue = configUrl.trim();

    return trimmedValue || null;
}

export function fetchSlotPluginsConfig(enabled: boolean, configUrl?: string | null): Promise<SlotPluginsConfig | null> {
    return fetchSlotPluginsConfigFromHost(getSlotPluginsConfigUrl(enabled, configUrl), { enabled });
}
